'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = setPlayingIndex;

var _players = require('../../store/actions/players');

var _store = require('../../store');

var _store2 = _interopRequireDefault(_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Copyright 2013-2015, Hudl
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule SetPlayingIndex
 */

function setPlayingIndex(playingIndex) {
  var players = _store2.default.storeInstance().getState().players;
  var playerId = Object.keys(players)[0];
  _store2.default.storeInstance().dispatch((0, _players.setPlayingIndex)(playerId, playingIndex));
}
module.exports = exports['default'];